var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSmileSadSolid = function SvgSmileSadSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h256v256H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M128 24a104 104 0 1 0 104 104A104.12 104.12 0 0 0 128 24m36 72a12 12 0 1 1-12 12 12 12 0 0 1 12-12m-72 0a12 12 0 1 1-12 12 12 12 0 0 1 12-12m81.586 86.922a7.9 7.9 0 0 1-4 1.078 8 8 0 0 1-6.93-3.992 40.4 40.4 0 0 0-6.375-8.297 39.8 39.8 0 0 0-12.71-8.57 40.3 40.3 0 0 0-31.141 0 40.1 40.1 0 0 0-19.078 16.867 8.002 8.002 0 0 1-13.852-8.016 56.022 56.022 0 0 1 97 0 7.99 7.99 0 0 1-2.914 10.93"
  })));
};
export default SvgSmileSadSolid;